module.exports = __webpack_public_path__ + "img/5G.56f3585b.jpg";